import { DeliveryTypeEnum } from "ReactApp/Types/enum";

class DeliveryType
{
    private static _instance: DeliveryType;

    public static get Instance() {
        return this._instance || (this._instance = new this());
    }

    asLabel(deliveryType: DeliveryTypeEnum, replacements: string[] = []): string {
        switch (deliveryType) {
            case DeliveryTypeEnum.carrier:
                return 'Курьером';
            break;
            case DeliveryTypeEnum.pickupFromSdek:
                return 'Самовывоз (СДЭК)';
            break;
        }
    }
}

export const deliveryTypeTransformer = DeliveryType.Instance;